export default __webpack_public_path__ + "img/eKKIFtkD.76448e3f.svg";